import {axios} from '../../services/axios';

export default async function createServiceProfiles({
    type,
    level,
    payload,
    scope,
}) {
    try {
        const result = await axios.post(
            `/serviceprofile/${type}/${level}`,
            payload,
            {
                headers: {
                    'X-RequestScope': scope,
                },
            },
        );
        return result;
    } catch (e) {
        throw e;
    }
}
